// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3646":"0cedacedd63594ba","7695":"a7ef513cc0b2cc59"}[chunkId] + ".js";
};